import { render, staticRenderFns } from "./soltList.vue?vue&type=template&id=169beabb&scoped=true&"
import script from "./soltList.vue?vue&type=script&lang=js&"
export * from "./soltList.vue?vue&type=script&lang=js&"
import style0 from "./soltList.vue?vue&type=style&index=0&id=169beabb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169beabb",
  null
  
)

export default component.exports